const CHANNEL = 'glyphicai-comic-episode-queue'

/** 通知其它标签页：话级生图任务已创建或仍在进行，便于恢复灵动岛 */
export function notifyComicEpisodeQueueActivity(): void {
  if (typeof BroadcastChannel === 'undefined') return
  try {
    new BroadcastChannel(CHANNEL).postMessage({ type: 'active' })
  } catch {
    /* ignore */
  }
}

export function subscribeComicEpisodeQueueActivity(onActivity: () => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  const bc = new BroadcastChannel(CHANNEL)
  bc.onmessage = () => onActivity()
  return () => bc.close()
}
